export default function InputField({
  label,
  name,
  value,
  onChange,
  error,
  type = 'text',
  placeholder = '',
}) {
  return (
    <div>
      <label className="block text-sm font-medium mb-1">{label}</label>

      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        onWheel={(e) => e.target.blur()}
        placeholder={placeholder}
        className={`w-full px-4 py-2 border rounded-lg focus:outline-none ${
          error ? 'border-red-500' : 'border-gray-300'
        }`}
      />

      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
}
